import {useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useThemeMode} from '../../../../_metronic/partials'

interface FilterModalProps {
  show: boolean
  handleClose: () => void
  tituloModal: string
  options: {value: string; label: string}[]
  tipoInput: string
  aplicarFiltros: (filtroSelect: string, filtroInput: string, filterInput2: string, filtroDescripcion: string, filtroDescripcion2: string) => void
  data?: {id: string | number | boolean; descripcion: string}[]
}

const FilterModal = ({
  show,
  handleClose,
  tituloModal,
  options,
  tipoInput,
  aplicarFiltros,
  data,
}: FilterModalProps) => {
  const [filtroSelect, setFiltroSelect] = useState('')
  const [filtroInput, setFiltroInput] = useState('')
  const [filtroDescripcion, setFiltroDescripcion] = useState('')
  const [filterInput2, setFilterInput2] = useState('')
  const [filtroDescripcion2, setFiltroDescripcion2] = useState('')
  const {mode} = useThemeMode()

  const [op, setOp] = useState('')

  const handleShow = () => {
    setFiltroSelect('')
    setFiltroInput('')
    setFiltroDescripcion('')
    setFilterInput2('')
    setFiltroDescripcion2('')
  }

  const condicionChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    // console.log(event.target.value)
    setOp(event.target.value)
    setFiltroSelect(event.target.value)
  }

  const handleAplicarFilter = () => {
    aplicarFiltros(filtroSelect, filtroInput, filterInput2, filtroDescripcion, filtroDescripcion2)
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onShow={handleShow}
      centered
      backdrop='static'
      dialogClassName='modal-dialog-centered mw-850px'
    >
      <Modal.Body>
        <h1 className='text-center fw-bolder m-0 text-uppercase'>{tituloModal}</h1>
        <div className='flex-row-fluid'>
          <div>
            <div>
              <div>
                <div className='mx-5 border-0 pt-1'>
                  <div className='row'>
                    <div className='py-3 col-4'>
                      <label className='col-form-label fw-bold fs-6'>Condición:</label>
                      <select
                        // className='form-select custom-input form-select-lg'
                        className={`form-select ${
                          mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                        }`}
                        value={filtroSelect}
                        // onChange={(e) => setFiltroSelect(e.target.value)}
                        onChange={condicionChange}
                      >
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {data ? (
                      <>
                        <div className='py-3 col-4'>
                          <label className='col-form-label fw-bold fs-6'>Valor:</label>

                          <select
                            className={`form-select ${
                              mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                            }`}
                            value={filtroInput}
                            onChange={(e) => {
                              const selectedOption = data.find(
                                (option) => option.id.toString() === e.target.value
                              )
                              if (selectedOption) {
                                // console.log(selectedOption.descripcion)
                                setFiltroDescripcion(selectedOption.descripcion)
                              }
                              setFiltroInput(e.target.value)
                            }}
                          >
                            {data.map((option, index) => (
                              <option key={index} value={option.id.toString()}>
                                {option.descripcion}
                              </option>
                            ))}
                          </select>
                        </div>

                        {filtroSelect === 'BT' ? (
                          <>
                            <div className='py-3 col-4'>
                              <label className='col-form-label fw-bold fs-6'>Valor:</label>

                              <select
                                className={`form-select ${
                                  mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                                }`}
                                value={filterInput2}
                                onChange={(e) => {
                                  setFilterInput2(e.target.value)
                                  setFiltroDescripcion2(e.target.value)
                                }}
                              >
                                {data.map((option, index) => (
                                  <option key={index} value={option.id.toString()}>
                                    {option.descripcion}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <>
                        <div className='py-3 col-4'>
                          <label className='col-form-label fw-bold fs-6'>Valor:</label>
                          <input
                            className={`form-control ${
                              mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                            }`}
                            type={tipoInput}
                            value={filtroInput}
                            onChange={(e) => {
                              setFiltroInput(e.target.value)
                              setFiltroDescripcion(e.target.value)
                            }}
                          />
                        </div>

                        {filtroSelect === 'BT' ? (
                          <>
                            <div className='py-3 col-4'>
                              <label className='col-form-label fw-bold fs-6'>Valor:</label>
                              <input
                                className={`form-control ${
                                  mode === 'dark' ? 'form-control-dark' : 'form-control-light'
                                }`}
                                type={tipoInput}
                                value={filterInput2}
                                onChange={(e) => {
                                  setFilterInput2(e.target.value)
                                  setFiltroDescripcion2(e.target.value)
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='d-flex flex-stack flex justify-content-end align-items-center mt-2'>
              <div>
                <Button variant='primary' onClick={handleAplicarFilter}>
                  Aplicar
                </Button>
                <Button variant='secondary' onClick={handleClose} className='mx-2'>
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default FilterModal
